<template>
  <SBIcon
    class="delivery-status"
    :class="{ 'up-1': status === 'sending' }"
    :icon="statusIcon.icon"
    :color="statusIcon.color"
    :size="statusIcon.size"/>
</template>

<script>
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'DeliveryStatus',
  components: {
    SBIcon,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    statusIcon() {
      const icon = {
        icon: SBIconList.MESSAGE_SENT,
        color: '#7c8b91',
        size: 11,
      };

      switch (this.status) {
        case 'sent':
          icon.icon = SBIconList.MESSAGE_TICK;
          icon.size = 12;
          break;
        case 'delivered':
          icon.icon = SBIconList.WHATSAPP_DELIVERED_TICK;
          icon.size = 16;
          break;
        case 'read':
          icon.icon = SBIconList.WHATSAPP_READ_TICK; // IDEA we could put different status icons for different platforms
          icon.color = '#2680eb';
          icon.size = 16;
          break;
        case 'failed':
          icon.icon = SBIconList.MESSAGE_FAILED;
          icon.color = '#ff5b61';
          icon.size = 9;
          break;
        default:
          break;
      }

      return icon;
    },
  },
};
</script>

<style lang="scss" scoped>
.delivery-status {
  margin-left: 4px;
  max-height: 12px;

  .icon {
    max-height: 12px;
  }
}
</style>
